import { getSlugValue } from 'utillities';

export const COMPANY_SUMMARY_SPREADSHEET_COLUMN_KEY_PREFIX = 'security';
export const COMPANY_SUMMARY_SPREADSHEET_COLUMN_NAME = 'Column';
export const COMPANY_SUMMARY_SPREADSHEET_COLUMN_NAME_PLURAL = 'Columns';
export const COMPANY_SUMMARY_SPREADSHEET_TITLE = 'Company Summary';
export const COMPANY_SUMMARY_SPREADSHEET_SLUG = getSlugValue(COMPANY_SUMMARY_SPREADSHEET_TITLE);
export const COMPANY_SUMMARY_SPREADSHEET_TABLE = `${COMPANY_SUMMARY_SPREADSHEET_SLUG}-table`;
